import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class PlantCareTemplateService {
  constructor(private apiHttp: ApiHttpService) {}

  public allPlantCareTemplates = (): Observable<PlantCareTemplate[]> => {
    return this.apiHttp.get<PlantCareTemplate[]>('plantcaretemplates');
  };

  public getPlantCareTemplate = (id: number): Observable<PlantCareTemplate> => {
    return this.apiHttp.get<PlantCareTemplate>(`plantcaretemplates/${id}`);
  }
}

export interface PlantCareTemplate {
    id: number;
    isActive: boolean;
    version: number;
    name: string;
    bpmDesignId: string;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/plant-care-template.service.ts